export default __webpack_public_path__ + "static/media/DSC08415.dba00600.jpg";